import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { LastLocationProvider } from 'react-router-last-location-17'

import AuthRoute from './containers/authRoute'
import { Hub } from './containers/hub'
import { Login } from './containers/login'
import { Logout } from './containers/logout'
import { NoMatch } from './components/noMatch'
import { ApiRedirect } from './components/apiRedirect'
import ConfigurationIndex from './features/configuration/configurationIndex'
import ConfigurationShow from './features/configuration/configurationShow'
import ConfigurationEdit from './features/configuration/configurationEdit'
import ConfigurationNew from './features/configuration/configurationNew'
import OrganizationIndex from './features/organization/organizationIndex'
import OrganizationShow from './features/organization/organizationShow'
import OrganizationEdit from './features/organization/organizationEdit'
import OrganizationNew from './features/organization/organizationNew'

import AdminCreate from './features/admin/adminCreate'
import AdminEdit from './features/admin/adminEdit'
import AdminIndex from './features/admin/adminIndex'
import AdminProfile from './features/admin/adminProfile'
import HistoryIndex from './features/history/historyIndex'
import ManualReviewRefiStatus from './components/manualReviewRefiStatus'
import ProductFilter from './features/products/productFilter'
import ProductIndex from './features/products/productIndex'
import RefiApp from './features/refiApp/refiApp'
import RefiStatusView from './components/refiStatusView'
import PaymentForm from './features/refiApp/paymentForm'
import DocumentSubmissionForm from './features/refiApp/documentSubmissionForm'
import FinancingApplication from './features/financing/financingApplication'
import RefiTransactionsAddProduct from './features/refiTransactions/refiTransactionsAddProduct'
import RefiTransactionsCustomToDo from './features/refiTransactions/refiTransactionsCustomToDo'
import RefiTransactionsDetails from './features/refiTransactions/refiTransactionsDetails'
import RefiTransactionsDocUpload from './features/refiTransactions/refiTransactionsDocUpload'
import RefiTransactionsEditLoanTerm from './features/refiTransactions/refiTransactionsEditLoanTerm'
import RefiTransactionsFilter from './features/refiTransactions/refiTransactionsFilter'
import RefiTransactionsIndex from './features/refiTransactions/refiTransactionsIndex'
import StipulationMappingEdit from './features/stipulationMappings/edit'
import StipulationMappingsIndex from './features/stipulationMappings/index'
import TaskFilter from './features/tasks/taskFilter'
import TaskIndex from './features/tasks/taskIndex'
import TaskModify from './features/tasks/taskModify'
import UnderwritingShow from './features/underwriting/show'
import UserAddressEdit from './features/users/userAddresses/userAddressEdit'
import UserAddressNew from './features/users/userAddresses/userAddressNew'
import UserAddresses from './features/users/userAddresses/userAddresses'
import UserCreateTicket from './features/users/userCreateTicket'
import UserFilter from './features/users/userFilter'
import UserIndex from './features/users/userIndex'
import UserProfile from './features/users/userProfile'
import UserProfileEdit from './features/users/userProfileEdit'
import VehicleDetails from './features/vehicles/vehicleDetails'
import VehicleEdit from './features/vehicles/vehicleEdit'
import VehicleIndex from './features/vehicles/vehicleIndex'
import VehiclesFilter from './features/vehicles/vehiclesFilter'
import RefiTransactionsLoanHistory from './features/refiTransactions/refiTransactionsLoanHistory'
import configurationLog from './features/configuration/configurationLog';
import CalltoolsError from './features/calltools/calltoolsError'

const Routes = () => (
  <LastLocationProvider>
    <Switch>
      <Route exact path="/logout" component={Logout} />
      <Route exact path="/login" component={Login} />
      <Route exact path="/calltools/error" component={CalltoolsError} />
      <AuthRoute exact path="/" component={Hub} />
      <AuthRoute
        exact
        path="/refiapp"
        component={RefiApp}
        requiredBadges={['REFI_PHONE']}
      />
      <AuthRoute
        exact
        path="/refiApp/financing/apply/ownership"
        component={FinancingApplication}
        requiredBadges={['REFI_PHONE']}
      />
      <AuthRoute
        exact
        path="/refiApp/financing/apply/applicant-info"
        component={FinancingApplication}
        requiredBadges={['REFI_PHONE']}
      />
      <AuthRoute
        exact
        path="/refiApp/financing/apply/residence-details"
        component={FinancingApplication}
        requiredBadges={['REFI_PHONE']}
      />
      <AuthRoute
        exact
        path="/refiApp/financing/apply/income-details"
        component={FinancingApplication}
        requiredBadges={['REFI_PHONE']}
      />
       <AuthRoute
        exact
        path="/refiApp/financing/apply/consent"
        component={FinancingApplication}
        requiredBadges={['REFI_PHONE']}
      />
       <AuthRoute
        exact
        path="/refiApp/financing/apply/disclosure-agreement"
        component={FinancingApplication}
        requiredBadges={['REFI_PHONE']}
      />
      <AuthRoute
        exact
        path="/refinance"
        component={RefiTransactionsIndex}
        requiredBadges={['REFIS']}
      />
      <AuthRoute
        exact
        path="/refinance/filters"
        component={RefiTransactionsFilter}
        requiredBadges={['REFIS']}
      />
      <AuthRoute
        exact
        path="/refinance/:id"
        component={RefiTransactionsDetails}
        requiredBadges={['REFIS']}
      />
      <AuthRoute
        exact
        path="/refinance/:id/uploaddocument"
        component={RefiTransactionsDocUpload}
      />
      <AuthRoute
        exact
        path="/refinance/:id/editloanterm"
        component={RefiTransactionsEditLoanTerm}
      />
      <AuthRoute
        exact
        path="/refinance/:id/addproduct"
        component={RefiTransactionsAddProduct}
      />
      <AuthRoute
        exact
        path="/refinance/:id/custom-todo"
        component={RefiTransactionsCustomToDo}
      />
      <AuthRoute
        exact
        path="/refinance/:id/loan-history"
        component={RefiTransactionsLoanHistory}
      />
      <AuthRoute
        exact
        path="/vehicles"
        component={VehicleIndex}
        requiredBadges={['VEHICLES']}
      />
      <AuthRoute
        exact
        path="/vehicles/filters"
        component={VehiclesFilter}
        requiredBadges={['VEHICLES']}
      />
      <AuthRoute
        exact
        path="/vehicles/:id"
        component={VehicleDetails}
        requiredBadges={['VEHICLES']}
      />
      <AuthRoute
        exact
        path="/vehicles/:id/edit"
        component={VehicleEdit}
        requiredBadges={['VEHICLES']}
      />
      <AuthRoute
        exact
        path="/admins"
        component={AdminIndex}
        anyBadges={['SUPERUSER', 'ADMIN']}
      />
      <AuthRoute
        exact
        path="/admins/:id/edit"
        component={AdminEdit}
        anyBadges={['SUPERUSER', 'ADMIN']}
      />
      <AuthRoute
        path="/admins/create"
        component={AdminCreate}
        anyBadges={['SUPERUSER', 'ADMIN']}
      />
      <AuthRoute
        exact
        path="/admins/:id"
        component={AdminProfile}
        anyBadges={['SUPERUSER', 'ADMIN']}
      />
      <AuthRoute
        exact
        path="/users"
        component={UserIndex}
        requiredBadges={['USERS']}
      />
      <AuthRoute
        exact
        path="/users/filters"
        component={UserFilter}
        requiredBadges={['USERS']}
      />
      <AuthRoute
        exact
        path="/users/:id"
        component={UserProfile}
        requiredBadges={['USERS']}
      />
      <AuthRoute
        exact
        path="/users/:id/create-ticket"
        component={UserCreateTicket}
        requiredBadges={['CREATE_ZENDESK_TICKET']}
      />
      <AuthRoute
        path="/users/:id/edit"
        component={UserProfileEdit}
        requiredBadges={['USERS', 'EDIT_USER']}
      />
      <AuthRoute exact path="/refiapp/rejected" component={RefiStatusView} />
      <AuthRoute
        exact
        path="/refiapp/review"
        component={ManualReviewRefiStatus}
      />
      <AuthRoute exact path="/refiapp/pending" component={RefiStatusView} />
      <AuthRoute exact path="/refiapp/unavailable" component={RefiStatusView} />
      <AuthRoute
        exact
        path="/refiapp/payment"
        component={PaymentForm}
        requiredBadges={['REFI_PHONE']}
      />
      <AuthRoute
        exact
        path="/refiapp/agreement"
        component={DocumentSubmissionForm}
        requiredBadges={['REFI_PHONE']}
      />
      <AuthRoute
        exact
        path="/users/:id/address"
        component={UserAddresses}
        requiredBadges={['USERS']}
      />
      <AuthRoute
        path="/users/:id/address/new"
        component={UserAddressNew}
        requiredBadges={['USERS', 'EDIT_USER']}
      />
      <AuthRoute
        path="/users/:userId/address/:addressId/edit"
        component={UserAddressEdit}
        requiredBadges={['USERS', 'EDIT_USER']}
      />
      <AuthRoute
        exact
        path="/products"
        component={ProductIndex}
        requiredBadges={[]}
      />
      <AuthRoute
        exact
        path="/products/filters"
        component={ProductFilter}
        requiredBadges={[]}
      />
      <AuthRoute
        exact
        path="/products/:id"
        component={UserProfile}
        requiredBadges={[]}
      />
      <AuthRoute
        exact
        path="/products/:id/create-ticket"
        component={UserCreateTicket}
        requiredBadges={[]}
      />
      <AuthRoute
        path="/products/:id/edit"
        component={UserProfileEdit}
        requiredBadges={[]}
      />
      <AuthRoute
        exact
        path="/products/:id/address"
        component={UserAddresses}
        requiredBadges={[]}
      />
      <AuthRoute
        path="/products/:id/address/new"
        component={UserAddressNew}
        requiredBadges={[]}
      />
      <AuthRoute
        path="/products/:userId/address/:addressId/edit"
        component={UserAddressEdit}
        requiredBadges={[]}
      />
      <AuthRoute
        exact
        path="/tasks"
        component={TaskIndex}
        requiredBadges={['TASKS']}
      />
      <AuthRoute
        exact
        path="/tasks/filters"
        component={TaskFilter}
        requiredBadges={['TASKS']}
      />
      <AuthRoute
        path="/tasks/:id/edit"
        component={TaskModify}
        requiredBadges={['TASKS']}
      />
      <AuthRoute
        path="/underwriting/:id"
        component={UnderwritingShow}
        requiredBadges={['UNDERWRITING']}
      />
      <AuthRoute
        exact
        path="/stipulation-mappings"
        component={StipulationMappingsIndex}
        requiredBadges={['UNDERWRITING']}
      />
      <AuthRoute
        path="/stipulation-mappings/:id"
        component={StipulationMappingEdit}
        requiredBadges={['UNDERWRITING']}
      />
      <AuthRoute exact path="/history" component={HistoryIndex} />
      <AuthRoute
        exact
        path="/configuration"
        component={ConfigurationIndex}
        requiredBadges={['SUPERUSER']}
      />
      <AuthRoute
        exact
        path="/configuration/new"
        component={ConfigurationNew}
        requiredBadges={['SUPERUSER']}
      />
      <AuthRoute
        exact
        path="/configuration/:id"
        component={ConfigurationShow}
        requiredBadges={['SUPERUSER']}
      />
      <AuthRoute
        exact
        path="/configuration/:id/logs"
        component={configurationLog}
        requiredBadges={['SUPERUSER']}
      />
      <AuthRoute
        exact
        path="/configuration/:id/edit"
        component={ConfigurationEdit}
        requiredBadges={['SUPERUSER']}
      />
      <AuthRoute
        exact
        path="/organizations"
        component={OrganizationIndex}
        requiredBadges={['SUPERUSER']}
      />
      <AuthRoute
        exact
        path="/organizations/new"
        component={OrganizationNew}
        requiredBadges={['SUPERUSER']}
      />
      <AuthRoute
        exact
        path="/organizations/:id"
        component={OrganizationShow}
        requiredBadges={['SUPERUSER']}
      />
      <AuthRoute
        exact
        path="/organizations/:id/edit"
        component={OrganizationEdit}
        requiredBadges={['SUPERUSER']}
      />
      <AuthRoute path="error/:statusCode" component={NoMatch} />
      <AuthRoute exact path="/api" component={ApiRedirect} />
      <AuthRoute path="*" component={NoMatch} />
    </Switch>
  </LastLocationProvider>
)

export default Routes
